/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getResultBidding } from 'store/modules/market_store/actions';
import { MarketState } from 'store/modules/market_store/types';
import Loader from 'components/atoms/loader';
import BiddingDate from 'components/atoms/bidding_date';
import BiddingAttachmentList from 'components/molecules/bidding_attachment_list';
import ProductsModal from 'components/atoms/products_modal';

interface BiddingMarketProps {
  params: {
    id?: string;
  };
  voltar?: { to: string; label: string };
}

const BiddingMarket = (props: BiddingMarketProps) => {
  const dispatch = useDispatch();
  const { params, voltar } = props;
  const { id = '' } = params;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [itemModal, setItemModal] = useState<any>({});

  const { bidding_result, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const dados = (result: object) => {
    setItemModal(result);
    setShowModal(true);
  };

  useEffect(() => {
    dispatch(getResultBidding(id));
  }, []);

  const calc = (result: any) => {
    let valor_global = 0;
    result.forEach((value: any) => {
      valor_global += value.item_valor_total;
    });

    if (valor_global === 0) {
      result.forEach((value: any) => {
        valor_global += value.item_valor_unitario;
      });
    }

    return valor_global.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  const calcVencedores = (result: any) => {
    const cnpjs: any[] = [];
    let vencedores = null;

    result.forEach((value: any) => {
      cnpjs.push(value.cnpj);
    });

    vencedores = cnpjs.filter(function (item, pos) {
      return cnpjs.indexOf(item) === pos;
    });
    return vencedores.length;
  };

  const biddingBody = () => {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <p>
              <b>Objeto</b> <br /> {bidding_result?.licitacao?.objeto}
            </p>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-4">
            <b>Datas</b>
            <div className="col-md-5">
              {!bidding_result?.licitacao?.datas?.datahora_abertura &&
                !bidding_result?.licitacao?.datas?.datahora_prazo &&
                !bidding_result?.licitacao?.datas?.datahora_documento &&
                !bidding_result?.licitacao?.datas?.datahora_retirada &&
                !bidding_result?.licitacao?.datas?.datahora_visita &&
                'Não Informadas'}
              {bidding_result?.licitacao?.datas?.datahora_abertura && (
                <BiddingDate
                  date={bidding_result?.licitacao?.datas?.datahora_abertura}
                  dateType="Abertura"
                />
              )}
              {bidding_result?.licitacao?.datas?.datahora_prazo && (
                <BiddingDate
                  date={bidding_result?.licitacao?.datas?.datahora_prazo}
                  dateType="Prazo"
                />
              )}
              {bidding_result?.licitacao?.datas?.datahora_documento && (
                <BiddingDate
                  date={bidding_result?.licitacao?.datas?.datahora_documento}
                  dateType="Documento"
                />
              )}
              {bidding_result?.licitacao?.datas?.datahora_retirada && (
                <BiddingDate
                  date={bidding_result?.licitacao?.datas?.datahora_retirada}
                  dateType="Retirada"
                />
              )}
              {bidding_result?.licitacao?.datas?.datahora_visita && (
                <BiddingDate
                  date={bidding_result?.licitacao?.datas?.datahora_visita}
                  dateType="Visita"
                />
              )}
            </div>
          </div>
          <div className="col-md-4">
            <p>
              <b>Nº ConLicitação</b> <br /> {bidding_result?.licitacao?.id}{' '}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>Situação</b> <br /> {bidding_result?.licitacao?.situacao}{' '}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <p>
              <b>Edital</b> <br /> {bidding_result?.licitacao?.edital}{' '}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>Processo</b> <br /> {bidding_result?.licitacao?.processo}{' '}
            </p>
          </div>
        </div>

        {bidding_result?.licitacao?.edital_status_id === 3 && (
          <div className="row">
            <div className="col-md-12">
              <b>Anexos</b>
              <br />
              <BiddingAttachmentList
                biddingStatusEdital={bidding_result?.licitacao?.edital_status_id}
                biddingFiles={bidding_result?.licitacao?.edicts}
              />
            </div>
          </div>
        )}

        <hr />

        <div className="row">
          <div className="col-md-4">
            <p>
              <b>Órgão</b> <br /> {bidding_result?.orgao?.nome}{' '}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>Código</b> <br /> {bidding_result?.orgao?.uasg}{' '}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <p>
              <b>Cidade</b> <br /> {bidding_result?.orgao?.cidade_uf}{' '}
            </p>
          </div>
          <div className="col-md-4">
            <p>
              <b>Endereço</b> <br /> {bidding_result?.orgao?.endereco}{' '}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <p>
              <b>Site</b> <br /> {bidding_result?.orgao?.site}{' '}
            </p>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12">
            <p>
              <b>Observação</b> <br /> {bidding_result?.licitacao?.observacao}{' '}
            </p>
          </div>
        </div>
      </>
    );
  };

  const resultBody = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <div className="card shadow p-0">
              <table className="table table-status-resultados mb-0">
                <tbody className="tbody-modal">
                  <tr>
                    <td className="text-center align-middle">
                      <b>Vencedores</b> <br /> {calcVencedores(bidding_result?.resultados)}
                    </td>
                    <td className="text-center align-middle">
                      <b>Nº de itens</b> <br /> {bidding_result?.resultados.length}
                    </td>
                    <td className="text-center align-middle">
                      <b>Valor global</b> <br /> {calc(bidding_result?.resultados)}
                    </td>
                    {/* {tdVisualizarAta} */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="card shadow p-0">
            <div className="table-responsive" style={{ maxHeight: '350px' }}>
              <table className="table table-hover table-resultados">
                <thead className="table-thead-fixed">
                  <tr>
                    <th className="w-25">Item</th>
                    <th>Vencedor</th>
                    <th>Un.</th>
                    <th>Qtd.</th>
                    <th>Valor un.</th>
                    <th>Valor total</th>
                  </tr>
                </thead>
                <tbody className="tbody-modal">
                  {bidding_result?.resultados.map((resultado) => (
                    <tr key={resultado.id}>
                      <td data-tip={resultado.item_descricao}>
                        <a
                          href="#"
                          onClick={() => {
                            dados(resultado);
                          }}
                          data-toggle="modal"
                          data-target="#productsAndServicesModal"
                        >
                          {resultado.item_descricao != null && resultado.item_descricao.length > 32
                            ? `${resultado.item_descricao.substring(0, 32)}...`
                            : resultado.item_descricao}
                        </a>{' '}
                      </td>
                      <td>
                        <a
                          href={
                            resultado.cnpj.toString().length === 13
                              ? `/concorrente/0${resultado.cnpj}`
                              : `/concorrente/${resultado.cnpj}`
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {resultado.fornecedor}
                        </a>
                      </td>
                      <td>{resultado.item_unidade}</td>
                      <td>{resultado.item_quantidade}</td>
                      <td>
                        {resultado.item_valor_unitario
                          ? resultado.item_valor_unitario.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : ' - '}
                      </td>
                      <td>
                        {resultado.item_valor_total
                          ? resultado.item_valor_total.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })
                          : ' - '}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ProductsModal showModal={showModal} setShowModal={setShowModal} products={itemModal} />
          </div>
        </div>
      </div>
    );
  };

  const followupBody = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card shadow p-0">
            <div className="table-responsive" style={{ maxHeight: '350px' }}>
              <table className="table table-hover table-acompanhamentos">
                <thead className="table-thead-fixed">
                  <tr>
                    <th>Síntese</th>
                    <th>Data da fonte</th>
                  </tr>
                </thead>
                <tbody className="tbody-modal">
                  {bidding_result?.acompanhamentos.map((acompanhamento) => (
                    <tr key={acompanhamento.id}>
                      <td>{acompanhamento.sintese}</td>
                      <td>{acompanhamento.data_fonte}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="container p-4 mt-5">
      <div className="row mb-3">
        <a href={voltar ? voltar.to : '/mercado'}>
          <i className="material-icons align-middle">keyboard_arrow_left</i>{' '}
          {voltar ? voltar.label : 'Voltar para análise de mercado'}
        </a>
      </div>
      <div className="row">
        <div className="card shadow col-12 p-0 my-3">
          <div
            className="card-title m-0 p-3 text-white navbar dark-bg mb-0"
            data-toggle="collapse"
            data-target="#licitacao"
            aria-expanded="false"
          >
            <h6 className="m-0">Licitação</h6>
            <i className="text-right material-icons">expand_more</i>
          </div>
          <div className="collapse show" id="licitacao">
            {request?.bidding_result?.loading ? (
              <Loader />
            ) : (
              bidding_result?.licitacao && <div className="card-body">{biddingBody()}</div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card shadow col-12 p-0 mb-3">
          <div
            className="card-title m-0 p-3 text-white navbar dark-bg mb-0"
            data-toggle="collapse"
            data-target="#resultados"
            aria-expanded="false"
          >
            <h6 className="m-0">Resultados</h6>
            <i className="text-right material-icons">expand_more</i>
          </div>
          <div className="collapse show" id="resultados">
            {request?.bidding_result?.loading ? (
              <Loader />
            ) : (
              bidding_result?.licitacao && <div className="card-body">{resultBody()}</div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="card shadow col-12 p-0 mb-3">
          <div
            className="card-title m-0 p-3 text-white navbar dark-bg mb-0"
            data-toggle="collapse"
            data-target="#acompanhamentos"
            aria-expanded="false"
          >
            <h6 className="m-0">Acompanhamentos</h6>
            <i className="text-right material-icons">expand_more</i>
          </div>
          <div className="collapse show" id="acompanhamentos">
            {request?.bidding_result?.loading ? (
              <Loader />
            ) : (
              bidding_result?.licitacao && <div className="card-body">{followupBody()}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BiddingMarket;
